module.exports = __webpack_public_path__ + "static/cc-working-process-c23e8f16d94c2a72c39d3ed1d2ba88b1.png";